<template>
  <v-text-field
    filled
    dense
    hide-details
    class="no-before mt-1"
    :value="value"
    type="number"
    min="0"
    step="1"
    :label="label"
    @change="e => $emit('input', Number(e))"
  >
    <template v-slot:append>
      <v-row
        align="center"
        justify="end"
        style="flex-wrap: nowrap;"
        no-gutters
        v-if="difference !== 0"
      >
        <v-icon v-if="difference > 0" color="success" left
          >fa-long-arrow-alt-down</v-icon
        >
        <v-icon v-else left color="error">fa-long-arrow-alt-up</v-icon>
        <span>{{ difference }}</span>
      </v-row>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "TillFondCaisseInput",
  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      default: ""
    },
    difference: {
      type: Number,
      required: true
    }
  }
};
</script>

<style></style>
